import { render, staticRenderFns } from "./AbpTable.vue?vue&type=template&id=88c38de2&scoped=true&"
import script from "./AbpTable.vue?vue&type=script&lang=ts&"
export * from "./AbpTable.vue?vue&type=script&lang=ts&"
import style0 from "./AbpTable.vue?vue&type=style&index=0&id=88c38de2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c38de2",
  null
  
)

export default component.exports